type SidebarContextType = {
  sidebarOpen: boolean;
  setSidebarOpen: (isOpen: boolean) => void;
  navItems: NavItem[];
  windowViewportWidth: number;
  setWindowViewportWidth: React.Dispatch<React.SetStateAction<number>>;
  viewAreaWidth: number;
  setViewAreaWidth: React.Dispatch<React.SetStateAction<number>>;
};

type NavItem = {
  id: string;
  label: string;
  icon: string | React.ReactNode;
  path: string;
  show: boolean;
  isBeta?: boolean;
};

enum GeneralViewNames {
  AgenticProcess = 'Agentic Process',
  AgentMiner = 'Agent Miner',
  Adherence = 'Risk Analysis',
  Portfolio = 'Portfolio',
  Strategy = 'Strategy',
  Financials = 'Financials',
  Process = 'Process Map',
  ProcessAnalysis = 'Process Analysis',
  DataManagement = 'Data Management',
  Integrations = 'Integrations',
  Dashboards = 'Dashboards',
  WorkPeriods = 'Work Periods',
  Flora = 'Flora',
  Calculations = 'Calculations',
}

export { GeneralViewNames };
export type { NavItem, SidebarContextType };
